const SWEETALERT_BLUE_BUTTON_CLASS =
  'inline-flex items-center justify-center rounded-md px-3 text-sm font-medium leading-4 shadow-sm border focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 border-transparent bg-blue-600 text-white hover:bg-blue-700 py-3 m-2';

const SWEETALERT_RED_BUTTON_CLASS =
  'inline-flex items-center justify-center rounded-md px-3 text-sm font-medium leading-4 shadow-sm border focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 border-transparent bg-red-600 text-white hover:bg-red-700 py-3 m-2';

export function sweetalertButtonClasses(swapColors: boolean = false): {
  confirmButton: string;
  cancelButton: string;
} {
  if (swapColors) {
    return {
      confirmButton: SWEETALERT_RED_BUTTON_CLASS,
      cancelButton: SWEETALERT_BLUE_BUTTON_CLASS
    };
  }

  return {
    confirmButton: SWEETALERT_BLUE_BUTTON_CLASS,
    cancelButton: SWEETALERT_RED_BUTTON_CLASS
  };
}
